export default __webpack_public_path__ + "static/media/VW.50cca823.png";